/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_ExtensionInputs */

const he_footer_extension = /** @type {(inputs: Footer_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תוסף לדפדפן`)
};

const en_footer_extension = /** @type {(inputs: Footer_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browser Extension`)
};

/**
* | output |
* | --- |
* | "Browser Extension" |
*
* @param {Footer_ExtensionInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const footer_extension = /** @type {((inputs?: Footer_ExtensionInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_ExtensionInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_footer_extension(inputs)
	return en_footer_extension(inputs)
});